<div id="card-tasks">
  <dx-data-grid
    *ngIf="currentTasks"
    #dataGrid
    [dataSource]="currentTasks"
    [columnAutoWidth]="true"
  >
    <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>

    <dxo-row-dragging
      [allowReordering]="true"
      [onReorder]="onReorder"
      [showDragIcons]="true"
    ></dxo-row-dragging>

    <dxi-column
      dataField="text"
      caption="Subject"
      [hidingPriority]="3"
    ></dxi-column>
    <dxi-column
      dataField="date"
      dataType="date"
      caption="Due Date"
      [hidingPriority]="1"
    ></dxi-column>
    <dxi-column
      caption="Assigned To"
      dataField="manager"
      [hidingPriority]="0"
    ></dxi-column>
  </dx-data-grid>

  <dx-load-panel
    [visible]="!currentTasks || isLoading"
    [showPane]="false"
    container="#card-tasks"
    [position]="{ of: '#card-tasks' }"
  ></dx-load-panel>
</div>
